import gql from "graphql-tag";

export default gql`
mutation SubmitReport(
    $name: String!
    $type: ReportType!
    $criteria: [ReportCriteriaInput!]!
    $tpID: ID!
    $contractIDs: [ID!]
    $useReportVersion: Int
){
    run_report(
        name: $name
        type: $type
        criteria: $criteria
        tpID: $tpID
        contractIDs: $contractIDs
        useReportVersion: $useReportVersion
    )
}
`